import { lazy, Suspense } from "react";
import { CircularProgress, Box } from "@mui/material";
import type { RouteConfig } from "./types";

const MapPage = lazy(() => import("../../MMS/pages/map"));

const MapWithSuspense = () => (
	<Suspense
		fallback={
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}>
				<CircularProgress />
			</Box>
		}>
		<MapPage />
	</Suspense>
);

export const mapRoutes: RouteConfig[] = [
	{
		path: "/map",
		element: <MapWithSuspense />,
	},
	{
		path: "/map/*",
		element: <MapWithSuspense />,
	},
];